{
  "menu": {
    "label": "Account",
    "organisation": "Organisation",
    "sessions": "Devices and sessions",
    "signOut": "Sign out",
    "signingOut": "Signing out"
  },
  "sessions": {
    "title": "Devices and sessions",
    "description": "Everywhere this account is signed in. Revoke anything you do not recognise — it stops working on the next request, not at the next sign-in.",
    "loading": "Loading your sessions",
    "empty": {
      "title": "No other sessions",
      "description": "This is the only device signed in to this account."
    },
    "current": "This device",
    "remembered": "Stays signed in",
    "lastActive": "Last active {{when}}",
    "expires": "Expires {{when}}",
    "unknownDevice": "Unrecognised browser",
    "unknownIp": "No address recorded",
    "device": "{{browser}} on {{platform}}",
    "revoke": "Revoke",
    "revoking": "Revoking",
    "revokeLabel": "Revoke the session on {{device}}",
    "revokeOthers": "Sign out everywhere else",
    "revokeOthersConfirm": {
      "title": "Sign out everywhere else?",
      "description": "Every other device will be signed out on its next request. This one stays signed in.",
      "confirm": "Sign out the others",
      "close": "Close"
    },
    "revokedOthers": "Signed out of {{count}} other session.",
    "revokedOthers_other": "Signed out of {{count}} other sessions.",
    "revokedOthersNone": "There was nothing else signed in.",
    "gone": {
      "title": "That session had already ended",
      "description": "It was revoked elsewhere, or it expired. The list below is up to date."
    }
  }
}
